import { c as _c } from "react/compiler-runtime";
import type { JSX } from 'react';
import styled from 'styled-components';
import { usePopover } from '../../hooks/popover';
import { colors } from '../../theme/colors';
import type { Employee } from '../employee-badge';
import { EmployeeBadge } from '../employee-badge';
import { EmployeesDetailsPopover } from '../employees-details-popover';
import type { EmployeeDetailsPopoverVariant } from '../employees-details-popover/types';
interface Props {
  employees: Employee[];
  onCopyEmail?: () => unknown;
  variant?: EmployeeDetailsPopoverVariant;
  containerId?: string;
  viewMoreHref?: string;
}
export function EmployeesRow(t0) {
  const $ = _c(35);
  const {
    employees,
    variant: t1,
    onCopyEmail,
    containerId,
    viewMoreHref
  } = t0;
  const variant = t1 === undefined ? "details" : t1;
  let t2;
  if ($[0] !== employees) {
    t2 = employees.slice(0, 4);
    $[0] = employees;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== employees) {
    t3 = employees.slice(4);
    $[2] = employees;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2 || $[5] !== t3) {
    t4 = [t2, t3];
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const [visibleEmployees, hiddenEmployees] = t4;
  const {
    popoverRef,
    targetRef,
    isPopoverOpen,
    togglePopover,
    closePopover
  } = usePopover();
  let t5;
  if ($[7] !== closePopover || $[8] !== containerId || $[9] !== hiddenEmployees || $[10] !== isPopoverOpen || $[11] !== onCopyEmail || $[12] !== popoverRef || $[13] !== targetRef || $[14] !== variant || $[15] !== visibleEmployees.length) {
    t5 = visibleEmployees.length > 0 && <EmployeesDetailsPopover popoverRef={popoverRef} targetRef={targetRef} isPopoverOpen={isPopoverOpen} closePopover={closePopover} employees={hiddenEmployees} variant={variant} onCopyEmail={onCopyEmail} containerId={containerId} />;
    $[7] = closePopover;
    $[8] = containerId;
    $[9] = hiddenEmployees;
    $[10] = isPopoverOpen;
    $[11] = onCopyEmail;
    $[12] = popoverRef;
    $[13] = targetRef;
    $[14] = variant;
    $[15] = visibleEmployees.length;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== onCopyEmail || $[18] !== variant || $[19] !== visibleEmployees) {
    let t7;
    if ($[21] !== onCopyEmail || $[22] !== variant) {
      t7 = employee => <EmployeeBadge key={employee.uuid} employee={employee} variant={variant} onCopyEmail={onCopyEmail} />;
      $[21] = onCopyEmail;
      $[22] = variant;
      $[23] = t7;
    } else {
      t7 = $[23];
    }
    t6 = visibleEmployees.map(t7);
    $[17] = onCopyEmail;
    $[18] = variant;
    $[19] = visibleEmployees;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  let t7;
  if ($[24] !== hiddenEmployees.length || $[25] !== targetRef || $[26] !== togglePopover || $[27] !== viewMoreHref) {
    t7 = hiddenEmployees.length > 0 && <div className="pl-1">{viewMoreHref ? <StyledButton type="button" href={viewMoreHref}>+{hiddenEmployees.length}</StyledButton> : <StyledButton type="button" onClick={togglePopover} ref={targetRef as React.RefObject<HTMLAnchorElement>}>+{hiddenEmployees.length}</StyledButton>}</div>;
    $[24] = hiddenEmployees.length;
    $[25] = targetRef;
    $[26] = togglePopover;
    $[27] = viewMoreHref;
    $[28] = t7;
  } else {
    t7 = $[28];
  }
  let t8;
  if ($[29] !== t6 || $[30] !== t7) {
    t8 = <div className="flex flex-row items-center gap-1">{t6}{t7}</div>;
    $[29] = t6;
    $[30] = t7;
    $[31] = t8;
  } else {
    t8 = $[31];
  }
  let t9;
  if ($[32] !== t5 || $[33] !== t8) {
    t9 = <>{t5}{t8}</>;
    $[32] = t5;
    $[33] = t8;
    $[34] = t9;
  } else {
    t9 = $[34];
  }
  return t9;
}
const StyledButton = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  background: none;
  color: ${colors.brand[400]};
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
  cursor: pointer;

  &:focus {
    outline: none;
  }
`;